import React from 'react'

import numeral from 'numeral'

import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AddToCartButton from './AddToCartButton'

function ProductPriceBuyActions({
  page, price, id, isPurchased = false, cartItems = EMPTY_ARRAY,
}) {
  function onAddToCartButtonClick() {
    if (page === 'product') {
      dataLayer.push({
        event: 'CustomEvent',
        eventCategory: 'Product Page',
        eventAction: 'Add to cart',
        eventLabel: `${price}`,
      })
    } else {
      dataLayer.push({
        event: 'CustomEvent',
        eventCategory: 'Product box popover',
        eventAction: 'New version',
        eventLabel: 'Add to cart',
      })
    }
  }

  function onMyPurchasesClick() {
    if (page === 'product') {
      dataLayer.push({
        event: 'CustomEvent',
        eventCategory: 'Product Page',
        eventAction: 'My Purchases',
        eventLabel: `${price}`,
      })
    } else {
      dataLayer.push({
        event: 'CustomEvent',
        eventCategory: 'Product box popover',
        eventAction: 'New version',
        eventLabel: 'My Purchases',
      })
    }

    window.location.href = '/profile/purchases'
  }

  function checkItemInCart() {
    return cartItems.includes(Number(id))
  }

  const metaSource = page === 'product' ? 'product_page' : 'product_overlay_page'

  return (
    <div className="product-pricing__buy-buttons">
      {isPurchased ? (
        <button
          className="btn btn-primary btn-block back-to-purchases"
          data-id={id}
          onClick={onMyPurchasesClick}
        >
          <Icon type={['fal', 'history']} />
          My purchases
        </button>
      ) : (
        <AddToCartButton
          id={id}
          price={numeral(price).format('$0.00')}
          metaSource={metaSource}
          callback={onAddToCartButtonClick}
          itemInCart={checkItemInCart()}
        />
      )}
    </div>
  )
}

ProductPriceBuyActions.propTypes = {
  page: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  isPurchased: PropTypes.bool,
  cartItems: PropTypes.array,
}

export default ProductPriceBuyActions
